/**
 * Public, unauthenticated application form route. Must match the URL the backend composes into
 * JobApplicantLinkDto.url, `{BaseUrl}applicants/{token}`.
 */
export const APPLICATION_FORM_ROUTE = '/applicants/:token';

export const buildApplicationFormPath = (token: string): string => `/applicants/${token}`;
